import React from 'react';
import c from './icon-display.module.scss';
import { getIcon } from '@monash/portal-frontend-common';

const IconDisplay = ({ icon, url }) => {
  if (!icon) {
    return null;
  }

  const FALLBACK_URL = 'https://monash.edu';

  const renderIcon = () => {
    switch (icon.type) {
      case 'emoji':
        return icon.character;
      case 'appIcon':
        return getIcon(icon.app, 32);
      case 'favicon':
        return (
          <img
            src={`https://www.google.com/s2/favicons?domain=${
              url || FALLBACK_URL
            }&sz=256`}
            alt=""
          />
        );
      default:
        return null;
    }
  };

  return <div className={c.icon}>{renderIcon()}</div>;
};

export default IconDisplay;
